import {inject, Injectable} from '@angular/core';
import {endpoints} from '../endpoints';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {BaseResponseApiRoot} from '../../models/user.model';

export interface OperatorViewConfigItem {
  voceMenu: string; // corrisponde a MenuItem.id
  canView: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OperatorViewsConfigService {

  private http = inject(HttpClient);

  /**
   * Recupera la configurazione delle viste per l'operatore corrente.
   * Può restituire null oppure una lista di {voceMenu, canView}.
   */
  getOperatorViewsConfig(): Observable<OperatorViewConfigItem[] | null> {
    const url = endpoints.operatorViewsConfigEndpoint;
    return this.http
    .get<BaseResponseApiRoot<OperatorViewConfigItem[] | null>>(url)
    .pipe(map(resp => resp?.res));
  }

}
